/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

// Fetch reservations
export const fetchReservations = async (data) => {
  const response = await api.get("/v1/admin/reservations", { params: data });
  return { data: response?.data, pageCount: response?.headers["total-count"] };
};

export const fetchEmployees = async (data) => {
  const response = await api.get("/v1/admin/employees", { params: data });
  return { data: response?.data, pageCount: response?.headers["total-count"] };
};

export const calculateValues = async (data) => {
  const response = await api.get("/v1/admin/reservations/value_calculator", {
    params: data,
  });
  return response?.data;
};

export const uploadReservations = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post("/v1/admin/reservations/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data;
};

export const fetchShifts = async () => {
  const response = await api.get("/v1/admin/shifts");
  return response?.data;
};

export const addShifts = async (data) => {
  const response = await api.post("v1/admin/shifts", { shift: data });
  return response;
};
